const showWindow=(strLabel)=>{
    console.log(`1 ${strLabel} host: %o`, window.location.host);
    console.log(`2 ${strLabel} hostname: %o`, window.location.hostname);
    console.log(`3 ${strLabel} href: %o`, window.location.href);
    console.log(`4 ${strLabel} origin: %o`, window.location.origin);
    console.log(`5 ${strLabel} pathname: %o`, window.location.pathname);
    console.log(`6  ----------`);
}
export { showWindow };